import "./Environment.module.css";
import Header from "@/reusable_sections/Header";
import Sustainabilityhero from "./sections/Sustainabilityhero";
import AwarenessGrid from "./sections/AwarenessGrid";
import Footer from "@/reusable_sections/Footer";
export default function EnvironmentPage() {
  return <div>
      <Header />
      <Sustainabilityhero />
      <AwarenessGrid />
      <Footer />
    </div>;
}